import { render, staticRenderFns } from "./add_social.vue?vue&type=template&id=38b3795f&scoped=true"
import script from "./add_social.vue?vue&type=script&lang=js"
export * from "./add_social.vue?vue&type=script&lang=js"
import style0 from "./add_social.vue?vue&type=style&index=0&id=38b3795f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3795f",
  null
  
)

export default component.exports